/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppFromJSONTyped, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp';
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp(json)) {
        return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInApp(value)) {
        return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureInAppToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp.js.map